<template>
  <div>
    <input-dropdown-logo
      v-if="bankNotListed"
      v-model="intitution"
      :options="institutionOptions"
      @change="$emit('bankSelected', $event.key)"
      :placeholder="$t('illion.dropdown.placeholder')"
      id="institution-input-dropdown"
    >
      <template #label>{{ $t('illion.dropdown.label') }}</template>

      <slot name="bank-selection-error-message" slot="bank-selection-error-message" />
    </input-dropdown-logo>
    <template v-else>
      <div class="tiles">
        <div
          v-for="institution in institutionLogos"
          class="tile"
          :key="institution.svgName"
          @click="$emit('bankSelected', institution.slug)"
        >
          <svg-use :name="institution.svgName" />
        </div>
      </div>

      <brand-link class="notListedLink" @click="bankNotListed = true">
        {{ $t('illion.bankNotListedLabel') }}
      </brand-link>
    </template>
  </div>
</template>
<script>
import InputDropdownLogo from '@/components/illionComponents/InputDropdownLogo';

export default {
  name: 'BankSelection',
  components: { InputDropdownLogo },
  props: {
    institutionLogos: {
      type: Array,
      default: () => [],
    },
    institutions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      bankNotListed: false,
      intitution: '',
    };
  },
  computed: {
    institutionOptions() {
      return this.institutions.map(({ slug, name, svgName }) => {
        return { key: slug, value: name, svgName };
      });
    },
  },
};
</script>
<style lang="sass" scoped>
.tiles
  width: 100%
  display: grid
  grid-template-columns: 1fr 1fr 1fr
  grid-gap: baseunit(2)
  background: $color-system-neutral-white
  +mq($ankylo)
    grid-template-columns: 1fr 1fr 1fr

.tile
  background: $color-system-neutral-gray-1
  width: 100%
  height: baseunit(9.6)
  padding: baseunit(1.6)

.notListedLink
  margin: baseunit(2) 0 baseunit(0.8)
  text-decoration: underline
</style>
